import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { setPageMeta } from '../lib/seo';

function NotFound() {
  useEffect(() => {
    setPageMeta({
      title: 'Page Not Found | Clouniq',
      description: 'The page does not exist or may have been moved.',
    });
  }, []);

  return (
    <section className="not-found-page">
      <div className="container">
        <div className="not-found-card">
          <span className="not-found-code">404</span>
          <h1 className="not-found-title">This route does not exist</h1>
          <p className="not-found-description">
            The page may have moved, or the URL might be outdated. You can continue from the main platform pages.
          </p>
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary">Go to homepage</Link>
            <Link to="/docs" className="btn btn-outline-primary">Open documentation</Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NotFound;



